import GenderChart from './gender-chart'
import EmployeeTypeChart from './employee-type-chart'
import LevelChart from './level-chart'
import NewEmployeeChart from './new-employee-chart'

export {
  GenderChart,
  EmployeeTypeChart,
  LevelChart,
  NewEmployeeChart,
}



// WEBPACK FOOTER //
// ./src/components/report/charts/headcount/index.js